import { useEffect, useState } from "react";
import styles from "./PopupProduct.module.css";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../../lib/get-image";
import { IoClose } from "react-icons/io5";

const ProductPopup = ({ products = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(true);

  // Static customer names
  const customerNames = ["Rahul", "Priya", "Arjun", "Sneha"];
  const [nameIndex, setNameIndex] = useState(0);

  useEffect(() => {
    if (!products.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === products.length - 1 ? 0 : prev + 1
      );

      setNameIndex((prev) => (prev + 1) % customerNames.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [products]);

  if (!showPopup || !products.length) return null;

  const product = products[currentIndex];

  return (
    <div className={styles.popupWrapper}>
      <button
        className={styles.closeBtn}
        onClick={() => setShowPopup(false)}
      >
        <IoClose />
      </button>

      <Link
        to={`/productdetails/${product.slug}`}
        className={styles.popup}
      >
        <img
          src={getImageUrl(product.thumb_image)}
          alt={product.name}
          className={styles.image}
        />

        <div className={styles.content}>
          <div className={styles.livePurchase}>
            <span className={styles.dot}></span>

            <p className={styles.text}>
              <strong>{customerNames[nameIndex]}</strong> purchased this
            </p>
          </div>

          <h4 className={styles.name}>{product.name}</h4>

          <p className={styles.price}>
            ₹{product.offer_price || product.price}.00
          </p>

        </div>
      </Link>
    </div>
  );
};

export default ProductPopup;